export default {
  buttons: {
    skip: 'Pomiń',
    back: 'Wstecz',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    payment: {
      pending: 'Twoja płatność jest przetwarzana...',
      success: '👍 Twoja płatność została pomyślnie przetworzona. Dziękujemy!',
      error:
        '⁉️Wystąpił problem z płatnością lub przetwarzanie trwa dłużej niż oczekiwano. Odśwież stronę przez 1 minutę, a w razie potrzeby skontaktuj się z pomocą techniczną.',
    },
  },
};
